import { BlockType } from "./Block";
import { EnhancedOpsSlot, Slot } from "./OpsSlot";

/** A reservation for a slot in the OPS. */
export class OpsReservation {
  /** The ID of the center. */
  centerId!: string;
  /** The ID of the service. */
  serviceId!: string;
  /** The slot being reserved. */
  slot!: Slot;

  constructor(centerId: string, serviceId: string | null | undefined, slot: EnhancedOpsSlot) {
    this.centerId = centerId as string;
    this.serviceId = serviceId as string;
    this.slot = {
      id: slot.id,
      startTimeUtc: slot.startTime.toUTC().toISO(),
      endTimeUtc: slot.endTime.toUTC().plus({ minutes: 60 }).toISO(),
      type: BlockType.Open
    };
  }
}
